module.exports =
  '_BASIC_ANALYSIS':
    'MY_AVG_TOTAL_SHOT': '平均スコア'
    'MY_AVG_PUTT': '平均パット数 '
    'PER_ONE_HOLE': '1ホール'
    'MY_GOAL': '目標'
    'ALL_MEMBERS_TOP': '会員'
    'ALL_MEMBERS_BELLOW': '平均'
    'FAIRWAY_HIT': 'フェアウェイキープ率'
    'RAT_PAR_ON': 'パーオン率'
    'RAT_BOGEY_ON': 'ボギーオン率'
    'THIS_YEAR': '当年'
    'LAST_3_MONTHS': '直近3ヶ月'
    'LAST_6_MONTHS': '直近6ヶ月'
    'ENTIRE_PERIOD': '全期間'

  '_SCORE_ANALYSIS':
    'TITLE': 'スコア分析'
    'EAGLE': 'イーグル以上'
    'BIRDIE': 'バーディ'
    'PAR': 'パー'
    'BOGEY': 'ボギー'
    'DBOGEY': 'ダブルボギー'
    'TRIPLE_BOGEY_OVER': 'トリプルボギー以上'

  '_STROKE_ANALYSIS':
    'TITLE':'平均ストローク数'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/i18n/ja.coffee